import React from 'react'

import Link, { LinkProps } from './global/Link'

type OptionalProductLinkProps = Omit<LinkProps, 'to'> & {
  urlKey: string | undefined | null
}

const OptionalProductLink: React.FC<OptionalProductLinkProps> = ({
  children,
  className,
  urlKey,
  ...restProps
}) =>
  urlKey ? (
    <Link className={className} to={`/products/${urlKey}`} {...restProps}>
      {children}
    </Link>
  ) : (
    <>{children}</>
  )

export default OptionalProductLink
